module.exports = __webpack_public_path__ + "static/people_pop1-3c58bfae63b04d42e775f9d92e87911c.png";